// stores.js
import { writable } from 'svelte/store';

export const userStore = writable({
    username: '-',
    url: 'https://twitter.com/',
});

export const tweetStore = writable({
    tweets: ['-'],
});

export const executiveSummaryStore = writable({
    executiveSummary: null,
});

export const graphDataStore = writable(null);